import { createSelector } from 'reselect';
import _ from 'lodash';

const SeminarRegisteredManagermentViewer = {
    createSeminarRegisteredManagermentViewerResultsSelector: () => createSelector([
        (state) => state.seminarRegisteredManagermentViewer.listSeminarRegistered.data.results,
    ], (results) => {
        if (!_.isEmpty(results)) {
            return results;
        }
        return [];
    }),
};

export default SeminarRegisteredManagermentViewer;
